import { S as SvgIcon, _ as __assign } from '../SvgIcon-9e6dc9e3.js';
import * as React from 'react';
import 'classnames';

function createSvgIcon(path, displayName, viewBox) {
    var Component = function (props, ref) { return (React.createElement(SvgIcon, __assign({ dataTestId: displayName + "Icon", ref: ref, viewBox: viewBox }, props), path)); };
    Component.displayName = displayName;
    return React.memo(React.forwardRef(Component));
}

export { createSvgIcon as default };
